import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/auth/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 注册方法
export function register(data) {
  return request({
    url: '/auth/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/system/user/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'delete'
  })
}

// 团队注册验证码
export const teamRegisterCode = (params) => {
  return request({
    url: '/auth/teamRegisterCode',
    method: 'get',
    params
  })
}

// 团队注册
export const teamRegister = (data) => {
  return request({
    url: '/auth/teamRegister',
    method: 'post',
    data
  })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword
  }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params: data
  })
}

// 忘记密码验证码
export const resetTeamPwdCode = (params) => {
  return request({
    url: '/auth/resetTeamPwd_code',
    method: 'get',
    params
  })
}

// 忘记密码
export const resetTeamPwd = (data) => {
  return request({
    url: '/auth/resetTeamPwd',
    method: 'post',
    data
  })
}

// 更改联系人验证码
export const updateContactCode = (params) => {
  return request({
    url: '/system/user/profile/updateContact_code',
    method: 'post',
    params
  })
}

// 更改联系人
export const updateContact = (data) => {
  return request({
    url: '/system/user/profile/updateContact',
    method: 'post',
    data
  })
}